import { render, staticRenderFns } from "./SplitListFunc.vue?vue&type=template&id=4b06c633&scoped=true"
import script from "./SplitListFunc.vue?vue&type=script&lang=js"
export * from "./SplitListFunc.vue?vue&type=script&lang=js"
import style0 from "./SplitListFunc.vue?vue&type=style&index=0&id=4b06c633&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b06c633",
  null
  
)

export default component.exports